import {
  ImpersonatedUserEmail,
  ImpersonatedUserId
} from '../constants/impersonateUser';

export const removeLocalStorageImpersonationData = () => {
  localStorage.removeItem(ImpersonatedUserEmail);
  localStorage.removeItem(ImpersonatedUserId);
};
